import { LoginStructure, UnauthenticatedLoginScreen } from "structure/login";
import { CLICK, componentWithVariants, demoFile, feature, story, variant } from "system/demo";
import { ZDFLoginScreenFeature } from "../login/zdf-login-screen";

demoFile('open-modules/zdf/feature/zdf-login-screen');

componentWithVariants(
    "ZDF - UnauthenticatedLoginScreen",
    UnauthenticatedLoginScreen,
    {
        config: { ...LoginStructure.receivesConfigDefaults, ...ZDFLoginScreenFeature.providesConfig },
    },
    [
        variant("Default", {}, [story("Continue with RC Internal", [CLICK("Continue with Radio Canada Internal")])]),
        variant(
            "Admin",
            {
                args: { action: "admin" },
            },
            [story("Continue with RC Internal", [CLICK("Continue with Radio Canada Internal")])]
        ),
    ]
);

feature('ZDF - Login Screen', {
    structureKey: 'login',

    features: {
        zdfloginscreen: true
    },
    state: {
        personaKey: null
    }
});